import className from 'classnames/bind';
import styles from './SocialLinks.module.scss';
import { LinkedInLogo, InstagramLogo, XLogo } from '..';

let cx = className.bind(styles);

export function SocialLinks({ className, hideMobile = false, hideDesktop = false }) {
	const classNameArray = className?.split(' ') || [];

	return (
		<div className={cx(['ns_social', 'social', hideMobile && 'hide-mobile', hideDesktop && 'hide-desktop', ...classNameArray])}>
			<h2 className="sr-only">Connect with Us</h2>
			<div className={cx(['ns_social-links', 'social-links'])}>
				<a href="https://www.linkedin.com/company/ouroglobal" target="_blank" rel="roreferrer noopener">
					<LinkedInLogo />
				</a>
				<a href="https://x.com/ouroglobal" target="_blank" rel="roreferrer noopener">
					<XLogo />
				</a>
				<a href="https://www.instagram.com/ouro.global/" target="_blank" rel="roreferrer noopener">
					<InstagramLogo />
				</a>
			</div>
		</div>
	);
}
